module.exports = __webpack_public_path__ + "assets/src/style/img/svg/logo-here-now-groningen.svg?d48580e0f9ad20f26f0de177aa3abefa";